import gql from 'graphql-tag';
import { parseToMutationRequest } from 'utils/utils';

export default data => {
  const dataModify = parseToMutationRequest(data, ['index']);
  const saveOutputTemplateByType = `saveOutputTemplateByType(input: ${dataModify})`;
  return gql`
  mutation {
    ${saveOutputTemplateByType} {
      id
    }
  }
`;
};
